const KEYS: Record<string, string> = {
  feature_disabled: 'aiAssistant.errors.featureDisabled',
  assistant_busy: 'aiAssistant.errors.busy',
  daily_limit_reached: 'aiAssistant.errors.dailyLimit',
  assistant_unavailable: 'aiAssistant.errors.unavailable',
  action_expired: 'aiAssistant.errors.actionExpired',
  client_calls_expired: 'aiAssistant.errors.clientCallsExpired',
  not_found: 'aiAssistant.errors.notFound',
  invalid_input: 'aiAssistant.errors.invalidInput',
};

type ErrorLike = {
  message?: unknown;
  graphQLErrors?: ReadonlyArray<{ message?: unknown }>;
};

export function assistantErrorCode(error: unknown): string {
  const candidate = error as ErrorLike | null | undefined;
  const graphQLMessage = candidate?.graphQLErrors?.[0]?.message;
  if (typeof graphQLMessage === 'string') return graphQLMessage;
  return typeof candidate?.message === 'string' ? candidate.message : '';
}

// Maps an assistant operation error to a translation key; raw backend text
// is never shown.
export function mapAssistantError(error: unknown): string {
  return KEYS[assistantErrorCode(error)] || 'aiAssistant.errors.generic';
}
